import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Tabs, Tab } from '@material-ui/core';
import {
	ScrollTab,
	CrudPengumuman,
	CrudDataPengumuman,
} from '../../components';

const useStyles = makeStyles({
	root: {
		flexGrow: 1,
	},
});

function TabPanel(props: any) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <div>{children}</div>}
		</div>
	);
}

function CenteredTabs({
	titlePengumuman,
	titleDataPengumuman,
	typePengumuman,
	typeDataPengumuman,
	hasContract,
}: any) {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const handleChange = (event: any, newValue: any) => {
		setValue(newValue);
	};

	return (
		<div className={classes.root}>
			<Tabs
				value={value}
				onChange={handleChange}
				indicatorColor="primary"
				textColor="primary"
				centered
			>
				<Tab label={titlePengumuman} />
				<Tab label={titleDataPengumuman} />
			</Tabs>
			<TabPanel value={value} index={0}>
				<CrudPengumuman
					title={titlePengumuman}
					type={typePengumuman}
					hasContract={hasContract}
				/>
			</TabPanel>
			<TabPanel value={value} index={1}>
				<CrudDataPengumuman
					title={titleDataPengumuman}
					type={typeDataPengumuman}
				/>
			</TabPanel>
		</div>
	);
}

const data = [
	{
		tab: 'Lowongan Pekerjaan',
		tabPanel: (
			<CenteredTabs
				titlePengumuman="Lowongan Pekerjaan"
				titleDataPengumuman="Form Aplikasi Lowongan"
				typePengumuman={7}
				typeDataPengumuman={1}
				hasContract
			/>
		),
	},
	{
		tab: 'Pengadaan Barang dan jasa',
		tabPanel: (
			<CenteredTabs
				titlePengumuman="Pengadaan Barang dan jasa"
				titleDataPengumuman="Form Aplikasi Pengadaan"
				typePengumuman={8}
				typeDataPengumuman={2}
			/>
		),
	},
	{
		tab: 'Pengumuman Lainnya',
		tabPanel: <CrudPengumuman title="Pengumuman Lainnya" type={9} />,
	},
];

const Pengumuman = () => {
	return <ScrollTab content={data} />;
};

export default Pengumuman;
